import { render, staticRenderFns } from "./ListarDiarioAeeTurmaPage.vue?vue&type=template&id=4a145662&scoped=true"
import script from "./ListarDiarioAeeTurmaPage.vue?vue&type=script&lang=js"
export * from "./ListarDiarioAeeTurmaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a145662",
  null
  
)

export default component.exports